module.exports = __webpack_public_path__ + "77954ded8d39c19ce37c14677ab80450.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-realisations/plats-du-chef/01.jpg
// module id = BNUY
// module chunks = 0